import mainCaller from './mainCaller';
import QueryString from 'qs';

// 상담 목록 조회 API (회원/잠재회원/지점 공용)
// GET /admin/api/v1/consultations
// params: { memberId?, temporaryUserId?, branchId?, dateFrom?, dateTo? }
// branchId, memberId, temporaryUserId 중 최소 하나 필수
export const getConsultationList = async (params, token) => {
  const query = QueryString.stringify(params, { skipNulls: true });
  return await mainCaller(`admin/api/v1/consultations?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 상담 단일 조회 API
// GET /admin/api/v1/consultations/{consultationId}
export const getConsultationById = async (consultationId, token) => {
  return await mainCaller(`admin/api/v1/consultations/${consultationId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 상담 생성 API (회원/잠재회원/비회원 공용)
// consultType: MEMBER | TEMPORARY | NON_MEMBER
// force=true 는 상담이 낀 일정 겹침을 사용자가 확인한 뒤 다시 보낼 때만 쓴다(withOverlapConfirm)
export const createConsultation = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/consultations${force ? '?force=true' : ''}`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 상담 수정 API
// PUT /admin/api/v1/consultations/{consultationId}
export const updateConsultation = async (consultationId, data, token, force = false) => {
  return await mainCaller(`admin/api/v1/consultations/${consultationId}${force ? '?force=true' : ''}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 상담 삭제 API
// DELETE /admin/api/v1/consultations/{consultationId}
export const deleteConsultation = async (consultationId, token) => {
  return await mainCaller(`admin/api/v1/consultations/${consultationId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};
